/**
 * Error message constants for external interfaces
 * Used to identify error messages without string matching
 */

export const ErrorMessages = {
    GENERIC_ERROR: "We ran into a problem. Please try again later or contact the administrator.",
};

export default ErrorMessages;
